import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppLogo from "../../components/AppLogo";
import ChangeLangButton from "../../components/language/ChangeLangButton";

function RestoreMassagePage() {
  const navigate = useNavigate();
  const LocalBasePath = "page.restoreMassage";
  //   TO USE FOR TRANSLATION:  {t(`${LocalBasePath}.`)} replace your key after dot
  const onPressLogin = () => {
    navigate("/login");
  };
  const { t } = useTranslation();

  return (
    <>
      <div className="min-h-screen flex flex-col  justify-between py-12 sm:px-6 lg:px-8">
        <div>
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <AppLogo />
            <h2 className="mt-6  text-3xl font-extrabold text-gray-900">
              {t(`${LocalBasePath}.restorePassword`)}
            </h2>
            <p className="mt-2  text-sm text-gray-600">
              {t(`${LocalBasePath}.restorePasswordSubtitle`)}
            </p>
          </div>

          <div className=" sm:mx-auto sm:w-full sm:max-w-md">
            <div className="mt-8 ">
              <div className="mt-6">
                <div className="mt-12">
                  <button
                    onClick={() => {
                      onPressLogin();
                    }}
                    type="button"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                  >
                    {t(`${LocalBasePath}.signIn`)}
                  </button>
                </div>
                <div className="mt-12">
                  <button
                    onClick={() => navigate("/1569842688742/password-reset")}
                    className="text-blue-500 active:bg-blue-600 "
                  >
                    http://www.sanad.com/1569842688742/password-reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ChangeLangButton />
      </div>
    </>
  );
}
export default RestoreMassagePage;
